import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import DataTable from '../DataTable/DataTable';
import InsurancesTableFilters from '../TableFilters/InsurancesTableFilters';
import styles from './insuranceTable.module.scss';

const InsurancesTable = (props) => {
  const { type, title, columns, tblData, isLoading, getInsuranceList } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [isCollapsed, setIsCollapsed] = useState(true);
  const [locFilters, setLocFilters] = useState({});
  const [dateRange, setDateRange] = useState({});
  const [filters, setFilters] = useState({});

  const toggleFiltersBlock = () => {
    setIsCollapsed(!isCollapsed);
  };

  const user = useSelector((store) => store.userReducer.user, shallowEqual);
  const userId = user.id;

  const loadData = useCallback((params) => {
    if (userId) {
      dispatch(getInsuranceList({ userId, params, filters }));
    }
  }, [userId, dispatch, getInsuranceList, filters]);

  const handleRowClick = (row) => {
    const { id } = row;
    history.push(`/contract/${type}/${id}`);
  };


  return (
    <div id={styles.tableContainer}>
      <div className={styles.table_title_row}>
        <div className="header">{t(title)}</div>
        <div className={styles.filterButton}>
          <button
            label="icon"
            type="button"
            className={cs({
              [styles.filter_icon]: true,
              [styles.expanded]: !isCollapsed,
              white_button: true,
            })}
            onClick={toggleFiltersBlock}
          />
        </div>
      </div>

      {!isCollapsed && (
        <InsurancesTableFilters
          locFilters={locFilters}
          setLocFilters={setLocFilters}
          dateRange={dateRange}
          setDateRange={setDateRange}
          filters={filters || {}}
          setFilters={setFilters}
        />
      )}

      <DataTable
        data={tblData.data}
        totalCount={tblData.total}
        columns={columns}
        loading={isLoading}
        onParamsChanges={loadData}
        handleRowClick={handleRowClick}
      />
    </div>
  );
};

InsurancesTable.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({})),
  tblData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    total: PropTypes.number,
  }),
  isLoading: PropTypes.bool,
  getInsuranceList: PropTypes.func,
};

InsurancesTable.defaultProps = {
  title: '',
  columns: [],
  tblData: null,
  isLoading: false,
  getInsuranceList: () => {},
};

export default InsurancesTable;
